
import logo from './logo.svg';
import './App.css';

import React, { useState, useEffect, useRef } from 'react';

import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Home } from './pages/Home';
import { Nav } from './components/Nav';
import { Footer } from './components/Footer';
import withLoading from './components/loading/Loading';
import About from './pages/About';
import Contact from './pages/Contact';
import Portfolio from './pages/Portfolio';
import Admin from './pages/Admin';
import Services from './pages/Services';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';


const HomeWL = withLoading(Home);
const AboutWL = withLoading(About);
const ContactWL = withLoading(Contact);
const PortfolioWL = withLoading(Portfolio);
const AdminWL = withLoading(Admin);
const ServicesWL = withLoading(Services);
const PrivacyWL = withLoading(Privacy);
const TermsWL = withLoading(Terms);

function App() {

  const [showNavbar, setShowNavbar] = useState(true);
  const prevScrollPosRef = useRef(0); // Track the previous scroll position
  const scrollThreshold = 20;

  useEffect(() => {
    const handleScroll = () => {
      // Use window.scrollY for getting the current vertical scroll position
      const currentScrollPos = window.scrollY;

      // Always show the navbar when scrolled to the very top
      if (currentScrollPos === 0) {
        setShowNavbar(true);
      } else if (prevScrollPosRef.current - currentScrollPos > scrollThreshold) {
        // Scrolled up by at least the threshold
        setShowNavbar(true);
      } else if (currentScrollPos - prevScrollPosRef.current > scrollThreshold) {
        // Scrolled down by at least the threshold
        setShowNavbar(false);
      }

      // Update the previous scroll position
      prevScrollPosRef.current = currentScrollPos;
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const location = useLocation(); // Hook to get the current path


  // Check if the current path is '/admin'
  const isAdminPage = location.pathname === '/admin';

  return (
    <div className="App">

      {!isAdminPage && <Nav showNavbar={showNavbar} />}

      <Routes>
        <Route path="/" element={<HomeWL />} />
        <Route path="/about" element={<AboutWL />} />
        <Route path="/contact" element={<ContactWL />} />
        <Route path="/portfolio" element={<PortfolioWL />} />
        <Route path="/admin" element={<AdminWL />} />
        <Route path='/services' element={<ServicesWL />} />
        <Route path='/terms' element={<TermsWL />} />
        <Route path='/privacy' element={<PrivacyWL />} />
      </Routes>

      {!isAdminPage && <Footer />}
    </div>
  );
}

function AppWrapper() {
  return (
    <Router>
      <App />
    </Router>
  );
}

export default AppWrapper;
